'use client';

import { ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  Container,
  Flex,
  Heading,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';

import LinkCustom from '@/app/_components/link/LinkCustom';

import NewsCard from '../NewsCard';

import Styles from './BlogList.module.scss';

export default function LatestBlogListSection({
  latestNewsBlogs,
}: {
  latestNewsBlogs: Array<{
    date_to_publish: string;
    mainImage: string | null;
    headerTitle: string;
    slug: string;
  }>;
}) {
  return (
    <>
      <Box
        className={Styles.latestNewsWrapper}
        paddingY={{ base: 20, sm: '100px' }}
      >
        <Container maxW={1280} width={'100%'} paddingX={{ base: 6, '2xl': 0 }}>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            flexWrap={'wrap'}
            alignItems={{ base: 'start', md: 'center' }}
            marginBottom={{ base: 16, md: 10 }}
            className={Styles.latestNewsHeader}
          >
            <Box className={Styles.headingElement}>
              <Text
                fontSize="xs"
                textTransform={'uppercase'}
                color={'white'}
                marginBottom={4}
              >
                Must read recommended articles
              </Text>
              <Heading
                as="h2"
                textTransform={'capitalize'}
                className={Styles.titleLg}
                color={'white'}
              >
                Latest News
              </Heading>
            </Box>
            <Box
              mt={{ base: 8, md: 0 }}
              marginLeft={{ md: 'auto' }}
              className={Styles.latestNewsHeaderCTA}
            >
              <LinkCustom
                role="link"
                aria-label="View All"
                className="btnOutlineWhite"
                href="/blog/latest-news"
              >
                View all
                <ChevronRightIcon width={4} height={4} marginLeft={3} />
              </LinkCustom>
            </Box>
          </Flex>
          <SimpleGrid columns={[1, 1, 2, 3]} gap={10}>
            {latestNewsBlogs?.map((blog, i) => (
              <NewsCard
                headingAs={'h5'}
                key={i}
                image={blog?.mainImage}
                title={blog?.headerTitle}
                date_to_publish={blog?.date_to_publish}
                slug={blog?.slug ?? ''}
              />
            ))}
          </SimpleGrid>
        </Container>
      </Box>
    </>
  );
}
